import config from './configureStore'

const store = config.configureStore()

export default store
